<template>
  <g-container>
    <g-contents>
      <h3 class="-mb-3">기본</h3>
      <ag-grid-vue style="height: 300px;"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :gridOptions="gridOptions"
          :rowData="rowData">
      </ag-grid-vue>
      <h3 class="-mb-3">필터링</h3>
      <ag-grid-vue style="height: 300px;"
          class="ag-theme-balham"
          :columnDefs="columnDefs"
          :rowData="rowData">
      </ag-grid-vue>
    </g-contents>
  </g-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import BadgeCell from '@/pages/components/ag-grid/BadgeCell'

export default {
  data () {
    return {
      columnDefs: null,
      rowData: null,
      gridOptions: null
    }
  },
  components: {
    AgGridVue
  },
  methods: {
    onClickDataChange () {
      const row = this.gridOptions.api.getDisplayedRowAtIndex(1)
      this.rowData[1].more = {
        ...this.rowData[1].more,
        bgColor: 'info',
        text: '바뀐텍스트'
      }
      const rowNodes = [row]
      this.gridOptions.api.redrawRows({ rowNodes })
    }
  },
  beforeMount () {
    this.gridOptions = {}
    this.columnDefs = [
      { field: 'no', headerName: 'No.' },
      { field: 'bill_month', headerName: '청구월' },
      { field: 'invoice_no', headerName: '인보이스 No.' },
      { field: 'invoice_publish_date', headerName: '인보이스 발행 일자' },
      { field: 'bill_total', headerName: '총 청구 금액' },
      { field: 'bill_status', headerName: '납부 상태' },
      { field: 'more', headerName: '추가 기능', cellRenderer: BadgeCell }
    ]

    this.rowData = [
      {
        no: 1,
        bill_month: '2020/10',
        invoice_no: '12837192',
        invoice_publish_date: '2020/12',
        bill_total: '39000',
        bill_status: '완납',
        more: {
          bgColor: 'info',
          text: '텍스트'
        }
      },
      {
        no: 1,
        bill_month: '2020/10',
        invoice_no: '12837192',
        invoice_publish_date: '2020/12',
        bill_total: '39000',
        bill_status: '완납',
        more: {
          bgColor: 'warning',
          text: '텍스트',
          onClickBadge: this.onClickDataChange
        }
      },
      {
        no: 1,
        bill_month: '2020/10',
        invoice_no: '12837192',
        invoice_publish_date: '2020/12',
        bill_total: '39000',
        bill_status: '완납',
        more: {
          bgColor: 'info',
          text: '텍스트'
        }
      }
    ]
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/sample/AgGridSample.vue